import script from "./AuthRecovery.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthRecovery.vue?vue&type=script&setup=true&lang=js"

import "./AuthRecovery.vue?vue&type=style&index=0&id=505f837e&scoped=true&lang=css"
import "./AuthRecovery.vue?vue&type=style&index=1&id=505f837e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-505f837e"]])

export default __exports__